import { BannerSchema } from '@/components/Banner/style/Banner.styles';

export const bannerStyles: BannerSchema = {
  bannerBoxProps: {
    bg: 'beta.700',
    borderRadius: 'md',
    border: 'none',
    gap: '3',
  },
  depositIconProps: {
    color: 'alpha.400',
    boxSize: '9',
  },
};
